import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { isJWTAuthorized } from "../pages/api/isJWTAuthorized";

export const useRedirectToHomeIfAuthorized = () => {
  const [hasCheckedAuth, setHasCheckedAuth] = useState(false);
  const router = useRouter();
  useEffect(() => {
    if (isJWTAuthorized()) {
      router.replace("/");
      return;
    }
    setHasCheckedAuth(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return hasCheckedAuth;
};
